module.exports = __webpack_public_path__ + "static/media/onda_desktop.1a0b5483.png";